export default __webpack_public_path__ + "static/media/close_icon.befc5c38.svg";